import type { AnimationsSettingRepository } from '@powerplay/core-minigames'
import { PlayerAnimationsNames } from '../types'
/**
 * Konfig pre animacie
 */
export const animationsConfig: AnimationsSettingRepository = {

  [PlayerAnimationsNames.happy1]: {
    loop: true,
    starting: false
  },
  [PlayerAnimationsNames.happy2]: {
    loop: true,
    starting: false
  },
  [PlayerAnimationsNames.happy3]: {
    loop: true,
    starting: false
  },
  [PlayerAnimationsNames.intro1]: {
    loop: true,
    starting: false
  },
  [PlayerAnimationsNames.intro2]: {
    loop: true,
    starting: false
  },
  [PlayerAnimationsNames.intro3]: {
    loop: true,
    starting: false
  },
  [PlayerAnimationsNames.intro4]: {
    loop: true,
    starting: false
  },
  [PlayerAnimationsNames.intro4_1]: {
    loop: true,
    starting: false
  },
  [PlayerAnimationsNames.neutral1]: {
    loop: true,
    starting: false
  },
  [PlayerAnimationsNames.neutral2]: {
    loop: true,
    starting: false
  },
  [PlayerAnimationsNames.sad1]: {
    loop: true,
    starting: false
  },
  [PlayerAnimationsNames.sad2]: {
    loop: true,
    starting: false
  },
  [PlayerAnimationsNames.prepare]: {
    loop: true,
    starting: true
  },
  [PlayerAnimationsNames.run]: {
    loop: true,
    starting: false
  },
  [PlayerAnimationsNames.runStop]: {
    loop: false,
    starting: false
  },
  [PlayerAnimationsNames.throw1]: {
    loop: false,
    starting: false
  },
  [PlayerAnimationsNames.throw2]: {
    loop: false,
    starting: false
  },
  [PlayerAnimationsNames.throw3]: {
    loop: false,
    starting: false
  },
  [PlayerAnimationsNames.windUp]: {
    loop: true,
    starting: false
  },

}

/** Specialny konfig pre animacie */
export const specialAnimationConfig = {

  /** randomizovanie animacii podla cisla trate */
  randomPercentByPathIndex: [0, 12.5, 25, 37.5, 50, 62.5, 75, 87.5].sort(() => (Math.random() - 0.5)),

  /** randomizacia pre animaciu ground to set */
  groundToSet: {

    // min a max pre random v sekundach
    min: 0,
    max: 0.2

  },

  /** randomizacia pre animaciu run */
  run: {

    // min a max pre random v sekundach
    min: 0,
    max: 0.2

  },

  /** randomizacia pre animaciu slow down run */
  slowDownRun: {

    // min a max pre random v sekundach
    min: 0,
    max: 0.2

  }

}
